import { MODE_OPTIONS, type LocationToolsMode } from "./locationToolsContentConstants";
import { FIREFLY_TARGET_ATTR } from "@/lib/firefly/fireflyTargetConvention";
import type { LocationToolsContentViewModel } from "./useLocationToolsContentModel";

export function LocationToolsContentToolbar({ vm }: { vm: LocationToolsContentViewModel }) {
  const {
    mode,
    setMode,
    setSelectedLinkId,
    setSelectedLocationId,
    canEdit,
    loading,
    persist,
    savedMsg,
  } = vm;

  return (
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
      <div className="flex flex-col sm:flex-row sm:items-center gap-3 flex-1 min-w-0">
        <label className="text-sm font-medium text-gray-700 dark:text-gray-300 shrink-0">What would you like to do?</label>
        <select
          {...{ [FIREFLY_TARGET_ATTR]: "lt-mode-picker" }}
          className="rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 px-3 py-2 text-sm text-gray-900 dark:text-gray-100 max-w-md w-full sm:w-auto"
          value={mode}
          onChange={(e) => {
            setMode(e.target.value as LocationToolsMode);
            setSelectedLinkId(null);
            setSelectedLocationId(null);
          }}
        >
          {MODE_OPTIONS.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
      </div>
      <div className="flex flex-col items-end gap-1.5 sm:shrink-0 w-full sm:w-auto min-w-0">
        {/* Slice 14: the "Manage locations" mode now mounts OrgLocationsSection,
            which owns its own create/edit affordances. The legacy "Save location"
            button is gone — only the link-editor modes need the persist button. */}
        {mode !== "addLocation" ? (
          <>
            <button
              type="button"
              {...{ [FIREFLY_TARGET_ATTR]: "lt-save-links" }}
              disabled={!canEdit || loading}
              onClick={() => void persist()}
              className="rounded-lg bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-700 disabled:opacity-50"
            >
              {loading ? "Loading…" : "Save to organization"}
            </button>
            {savedMsg ? (
              <p className="text-sm text-emerald-700 dark:text-emerald-400 text-right max-w-full sm:max-w-xs break-words">
                {savedMsg}
              </p>
            ) : null}
          </>
        ) : null}
      </div>
    </div>
  );
}
